import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  HostListener,
  Input,
  ViewChild,
} from '@angular/core';
import { SuperTableCheckbox } from './super-table-checkbox.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: '[superTableCell]',
  styleUrls: ['./super-table-cell.component.scss'],
  templateUrl: './super-table-cell.component.html',
})
export class SuperTableCellComponent {
  @HostBinding('class.checkbox')
  @Input()
  checkbox: any;

  @Input()
  checkboxDisabled: boolean = false;

  @Input()
  columnName: string;

  @ViewChild(SuperTableCheckbox, { static: false })
  superTableCheckbox: SuperTableCheckbox<unknown>;

  @HostListener('click', ['$event'])
  click(event: MouseEvent) {
    const tagName = (<Element>event.target).tagName;
    if (tagName === 'A' || tagName === 'BUTTON' || tagName === 'INPUT') {
      event.stopPropagation();
    }
  }
}
